/** Short package/batch id for dense dashboard cards (full value in title). */
export function shortPackageRef(value) {
  const text = String(value || '').trim();
  if (!text) return '—';
  if (text.length <= 14) return text;
  return `${text.slice(0, 8)}…${text.slice(-4)}`;
}
